import { ApiConfig } from './api';
import { fetchWrapper } from './utils/http-utils';

export const get =
  (config: ApiConfig) =>
  (publicFileKey: string): Promise<Record<string, any>> =>
    fetchWrapper<Record<string, any>>(
      `local-api/${publicFileKey}`,
      {
        method: 'GET',
      },
      config
    );
